import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-bold uppercase tracking-[0.2em] text-slate-400" }, "Pagamento"),
  /*#__PURE__*/_createElementVNode("span", { class: "rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-400" }, "até 2 opções")
], -1)
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = { class: "flex cursor-pointer items-center gap-3 p-4" }
const _hoisted_5 = ["checked", "disabled", "onChange"]
const _hoisted_6 = { class: "flex h-10 w-12 items-center justify-center rounded-xl border border-slate-100 bg-white p-2 shadow-sm" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "text-sm text-slate-950" }
const _hoisted_9 = {
  key: 0,
  class: "border-t border-slate-100 p-4 pt-3"
}
const _hoisted_10 = { class: "mb-2 text-xs text-slate-500" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "mt-2 text-xs text-red-600" }
const _hoisted_13 = {
  key: 1,
  class: "border-t border-slate-100 p-4 pt-3"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 rounded-xl border border-slate-200 bg-slate-50 p-3 text-xs text-slate-500" }, " Você receberá os dados para realizar o pagamento Pix ao finalizar a compra. ", -1)
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "mt-2 text-xs text-red-600" }
const _hoisted_17 = {
  key: 2,
  class: "space-y-4 border-t border-slate-100 p-4 pt-3"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "text-xs font-semibold text-slate-600" }, "Valor a pagar", -1)
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "mt-2 text-xs text-red-600" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "text-xs font-semibold text-slate-600" }, "Tipo do cartão", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Selecione", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Visa", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "MasterCard", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Elo", -1)
const _hoisted_27 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_29 = { class: "grid grid-cols-1 gap-3 sm:grid-cols-2" }
const _hoisted_30 = ["data-maska", "value", "placeholder", "onInput"]
const _hoisted_31 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_32 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_33 = { class: "text-xs font-semibold text-slate-600" }
const _hoisted_34 = ["value"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Mês", -1)
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_38 = { class: "text-xs font-semibold text-slate-600" }
const _hoisted_39 = ["value"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Ano", -1)
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 text-xs font-bold uppercase tracking-[0.16em] text-slate-400" }, "Dados de cobrança", -1)
const _hoisted_44 = { class: "grid grid-cols-1 gap-3 sm:grid-cols-2" }
const _hoisted_45 = ["data-maska", "value", "placeholder", "onInput"]
const _hoisted_46 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_47 = { class: "text-xs font-semibold text-slate-600" }
const _hoisted_48 = ["value"]
const _hoisted_49 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_50 = { class: "text-xs font-semibold text-slate-600" }
const _hoisted_51 = ["value"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Estado", -1)
const _hoisted_53 = ["value"]
const _hoisted_54 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}
const _hoisted_55 = ["data-maska", "value", "placeholder", "onInput"]
const _hoisted_56 = {
  key: 0,
  class: "mt-1 text-xs text-red-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("div", {
          key: option.key,
          class: "rounded-xl border border-slate-200"
        }, [
          _createElementVNode("label", _hoisted_4, [
            _createElementVNode("input", {
              type: "checkbox",
              checked: option.checked,
              disabled: option.disabled,
              onChange: ($event: any) => (_ctx.$emit('toggle', option.key, ($event.target as HTMLInputElement).checked))
            }, null, 40, _hoisted_5),
            _createElementVNode("span", _hoisted_6, [
              (option.image)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: option.image,
                    alt: option.label,
                    class: "max-h-full max-w-full object-contain"
                  }, null, 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: _normalizeClass(["flex h-6 w-6 items-center justify-center rounded-full text-xs font-bold text-white", option.color])
                  }, _toDisplayString(option.badge), 3))
            ]),
            _createElementVNode("strong", _hoisted_8, _toDisplayString(option.label), 1)
          ]),
          (option.key == 'ecash' && option.checked)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, [
                  _createTextVNode("Saldo disponível: "),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.eCashBalance).replace('R', 'E')), 1)
                ]),
                _createElementVNode("input", {
                  value: _ctx.dataEcash,
                  placeholder: "0,00",
                  class: "h-11 w-full rounded-xl border border-slate-200 px-3 text-sm outline-none focus:border-slate-950",
                  onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:dataEcash', ($event.target as HTMLInputElement).value)))
                }, null, 40, _hoisted_11),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.missingValue), 1)
              ]))
            : _createCommentVNode("", true),
          (option.key == 'pix' && option.checked)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("input", {
                  value: _ctx.dataPix,
                  placeholder: "0,00",
                  class: "h-11 w-full rounded-xl border border-slate-200 px-3 text-sm outline-none focus:border-slate-950",
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:dataPix', ($event.target as HTMLInputElement).value)))
                }, null, 40, _hoisted_15),
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.missingValue), 1)
              ]))
            : _createCommentVNode("", true),
          (option.key == 'creditCard' && option.checked)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", null, [
                  _hoisted_18,
                  _createElementVNode("input", {
                    value: _ctx.dataCreditCard,
                    placeholder: "0,00",
                    class: "mt-1 h-11 w-full rounded-xl border border-slate-200 px-3 text-sm outline-none focus:border-slate-950",
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:dataCreditCard', ($event.target as HTMLInputElement).value)))
                  }, null, 40, _hoisted_19),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.missingValue), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_21,
                  _createElementVNode("select", {
                    value: _ctx.form.typeCard,
                    class: "mt-1 h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm outline-none focus:border-slate-950",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update-form', 'typeCard', ($event.target as HTMLSelectElement).value)))
                  }, _hoisted_27, 40, _hoisted_22),
                  (_ctx.errors.typeCard)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(_ctx.errors.typeCard), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardInfo, (item) => {
                    return (_openBlock(), _createElementBlock("label", {
                      key: item.id,
                      class: _normalizeClass(["text-xs font-semibold text-slate-600", item.id == 'cardNumber' ? 'sm:col-span-2' : ''])
                    }, [
                      _createTextVNode(_toDisplayString(item.label) + " ", 1),
                      _withDirectives(_createElementVNode("input", {
                        "data-maska": item.mask,
                        value: item.value,
                        placeholder: item.placeholder,
                        class: "mt-1 h-11 w-full rounded-xl border border-slate-200 px-3 text-sm outline-none focus:border-slate-950",
                        onInput: ($event: any) => (item.value = ($event.target as HTMLInputElement).value)
                      }, null, 40, _hoisted_30), [
                        [_directive_maska]
                      ]),
                      (item.error)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(item.error), 1))
                        : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", _hoisted_33, [
                    _createTextVNode(" Mês "),
                    _createElementVNode("select", {
                      value: _ctx.form.month,
                      class: "mt-1 h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm outline-none focus:border-slate-950",
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update-form', 'month', ($event.target as HTMLSelectElement).value)))
                    }, [
                      _hoisted_35,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: month,
                          value: month
                        }, _toDisplayString(month), 9, _hoisted_36))
                      }), 128))
                    ], 40, _hoisted_34),
                    (_ctx.errors.month)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.errors.month), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("label", _hoisted_38, [
                    _createTextVNode(" Ano "),
                    _createElementVNode("select", {
                      value: _ctx.form.year,
                      class: "mt-1 h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm outline-none focus:border-slate-950",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('update-form', 'year', ($event.target as HTMLSelectElement).value)))
                    }, [
                      _hoisted_40,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: year,
                          value: year.toString()
                        }, _toDisplayString(year), 9, _hoisted_41))
                      }), 128))
                    ], 40, _hoisted_39),
                    (_ctx.errors.year)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString(_ctx.errors.year), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalInfo.slice(0, 2), (item) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: item.id,
                        class: "text-xs font-semibold text-slate-600 sm:col-span-2"
                      }, [
                        _createTextVNode(_toDisplayString(item.label) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          "data-maska": item.mask,
                          value: item.value,
                          placeholder: item.placeholder,
                          class: "mt-1 h-11 w-full rounded-xl border border-slate-200 px-3 text-sm outline-none focus:border-slate-950",
                          onInput: ($event: any) => (item.value = ($event.target as HTMLInputElement).value)
                        }, null, 40, _hoisted_45), [
                          [_directive_maska]
                        ]),
                        (item.error)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(item.error), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("label", _hoisted_47, [
                      _createTextVNode(" CEP "),
                      _withDirectives(_createElementVNode("input", {
                        value: _ctx.form.cep,
                        "data-maska": "#####-###",
                        class: "mt-1 h-11 w-full rounded-xl border border-slate-200 px-3 text-sm outline-none focus:border-slate-950",
                        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update-form', 'cep', ($event.target as HTMLInputElement).value)))
                      }, null, 40, _hoisted_48), [
                        [_directive_maska]
                      ]),
                      (_ctx.errors.cep)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(_ctx.errors.cep), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("label", _hoisted_50, [
                      _createTextVNode(" Estado "),
                      _createElementVNode("select", {
                        value: _ctx.form.state,
                        class: "mt-1 h-11 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm outline-none focus:border-slate-950",
                        onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update-form', 'state', ($event.target as HTMLSelectElement).value)))
                      }, [
                        _hoisted_52,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: state.acronym,
                            value: state.state.toLowerCase()
                          }, _toDisplayString(state.acronym), 9, _hoisted_53))
                        }), 128))
                      ], 40, _hoisted_51),
                      (_ctx.errors.state)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(_ctx.errors.state), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.personalInfo.slice(2), (item) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: item.id,
                        class: _normalizeClass(["text-xs font-semibold text-slate-600", item.id == 'complement' ? 'sm:col-span-2' : ''])
                      }, [
                        _createTextVNode(_toDisplayString(item.label) + " ", 1),
                        _withDirectives(_createElementVNode("input", {
                          "data-maska": item.mask,
                          value: item.value,
                          placeholder: item.placeholder,
                          class: "mt-1 h-11 w-full rounded-xl border border-slate-200 px-3 text-sm outline-none focus:border-slate-950",
                          onInput: ($event: any) => (item.value = ($event.target as HTMLInputElement).value)
                        }, null, 40, _hoisted_55), [
                          [_directive_maska]
                        ]),
                        (item.error)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(item.error), 1))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}